export default "__VITE_ASSET__DL9pTCxR__"